function escapeControlCharsInJsonStrings(json) {
  if (!json) {
    return json;
  }

  let escaped = '';
  let inString = false;
  let isEscaped = false;

  for (const char of json) {
    if (inString) {
      if (isEscaped) {
        escaped += char;
        isEscaped = false;
        continue;
      }

      if (char === '\\') {
        escaped += char;
        isEscaped = true;
        continue;
      }

      if (char === '"') {
        escaped += char;
        inString = false;
        continue;
      }

      const codePoint = char.charCodeAt(0);
      if (codePoint <= 0x1f) {
        switch (char) {
          case '\b':
            escaped += '\\b';
            break;
          case '\f':
            escaped += '\\f';
            break;
          case '\n':
            escaped += '\\n';
            break;
          case '\r':
            escaped += '\\r';
            break;
          case '\t':
            escaped += '\\t';
            break;
          default:
            escaped += `\\u${codePoint.toString(16).padStart(4, '0')}`;
        }
        continue;
      }
    } else if (char === '"') {
      inString = true;
    }

    escaped += char;
  }

  return escaped;
}

export default function renderCanvasJsonTemplate(canvasJson, textTemplate) {
  return escapeControlCharsInJsonStrings(
    textTemplate.renderMustache(canvasJson)
  );
}

export { escapeControlCharsInJsonStrings };
